{
  "name": "broccoli",
  "version": "1.0.0",
  "license": "NTP",
  "repository": {
    "url": "https://github.com/mathieucaroff/broccoli"
  },
  "scripts": {
    "check": "tsc --noEmit",
    "checkwatch": "tsc --noEmit --watch",
    "build": "parcel build src/index.html --dist-dir public",
    "mcabuild": "parcel build src/index.html --public-url broccoli.d",
    "serve": "parcel src/index.html"
  },
  "dependencies": {
    "nearley": "^2.20.1"
  },
  "devDependencies": {
    "@parcel/transformer-inline-string": "2.3.2",
    "@parcel/transformer-yaml": "2.3.2",
    "@types/nearley": "^2.11.2",
    "parcel": "^2.3.2",
    "parcel-transformer-nearley": "^1.0.4",
    "specimen-test": "^0.1.4",
    "typescript": "^4.6.2"
  }
}
